import React, { createContext, useContext, useReducer } from "react";
import PropTypes from "prop-types";
import { HOSPICE_SECTIONS_CHECKBOX_FIELDS, SHIFT_LOG_TASK_FIELDS } from "../../constants";

const initialState = {
  clientName: true,
  shiftNumber: true,
  location: true,
  loggedBy: true,
  whatHappened: true,
  isSeen: "All"
};
const DenseViewContext = createContext(null);

function reducer(state, action) {
  if (action.type === "selectAll") {
    return {
      ...state,
      ...SHIFT_LOG_TASK_FIELDS.reduce((acc, field) => ({ ...acc, [field.value]: true }), {}),
      ...HOSPICE_SECTIONS_CHECKBOX_FIELDS.reduce(
        (acc, field) => ({ ...acc, [field.value]: true }),
        {}
      )
    };
  }
  if (action.type === "deselectAll") {
    return {
      ...state,
      ...SHIFT_LOG_TASK_FIELDS.reduce((acc, field) => ({ ...acc, [field.value]: false }), {}),
      ...HOSPICE_SECTIONS_CHECKBOX_FIELDS.reduce(
        (acc, field) => ({ ...acc, [field.value]: false }),
        {}
      )
    };
  }
  if (action.type === "Hygiene") {
    const newState = { ...state };
    SHIFT_LOG_TASK_FIELDS.forEach((field) => {
      newState[field.value] = action.payload;
    });
    newState["Hygiene"] = action.payload;
    return newState;
  }

  return { ...state, [action.type]: action.payload };
}

function useDenseViewContext() {
  const context = useContext(DenseViewContext);
  return context;
}

function DenseViewContextProvider({ children, location }) {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    ...HOSPICE_SECTIONS_CHECKBOX_FIELDS.reduce(
      (acc, field) => ({ ...acc, [field.value]: true }),
      {}
    ),
    ...SHIFT_LOG_TASK_FIELDS.reduce((acc, field) => ({ ...acc, [field.value]: true }), {})
  });

  return (
    <DenseViewContext.Provider value={{ state, dispatch, location }}>
      {children}
    </DenseViewContext.Provider>
  );
}
DenseViewContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.string.isRequired
};

export default DenseViewContextProvider;
export { useDenseViewContext };
